<script>
  let klass = '';
  export { klass as class };
  export let size = '24px';
  export let width = size;
  export let height = size;
  export let viewWidth = '24';
  export let viewHeight = '24';
  export let rotate = 0;
  export let spin = false;
  export let disabled = false;
  export let path = null;
  export let label = null;
  export let style = '';
  export let color = 'white'
  export let svg = false;
  export let strokeWidth = ''

  $: {
    width = size;
    height = size;
  }


</script>


<i
  on:click
  aria-hidden="true"
  class="s-icon {klass}"
  class:spin
  aria-label={label}
  class:disabled
  aria-disabled={disabled}
  style='font-size: {size}; stroke-width: {strokeWidth}; transform: rotate({rotate}deg); color:{color}; stroke:{color}; fill:{color}; {style}'>
  {#if svg}
  {@html svg}
  {:else if path}
  <svg
    xmlns="http://www.w3.org/2000/svg"
    {width}
    {height}
    viewBox="0 0 {viewWidth} {viewHeight}">
    <path d={path}>
      {#if label}
        <title>{label}</title>
      {/if}
    </path>
  </svg>
  {/if}
  <slot />
</i>

<style>
  .s-icon {
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-flex;
    font-feature-settings: 'liga';
    justify-content: center;
    position: relative;
    align-items: center;
    text-indent: 0;
    vertical-align: middle;
    cursor: inherit;
    user-select: none;
    direction: ltr;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
  }
  .s-icon.disabled {
    color: rgb(172, 172, 172);
  }
  .s-icon.spin {
    animation: infinite s-icon-spin linear 1s;
  }
  @keyframes s-icon-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
